const menu = init => store => {
  store.on('@init', () => ({ menu: {open: false, items: init}}));
  store.on('menu/change', ({ menu }) => ({ menu: {open: !menu.open, items: menu.items}}));
};

export default menu;
